import React from "react"
export function FlexiflyLogoPlusTagline(props) {
  return (
    <svg viewBox="0 0 190 65" {...props}>
      <defs>
        <filter
          x="-2.9%"
          y="-3.2%"
          width="105.8%"
          height="105.8%"
          filterUnits="objectBoundingBox"
          id="prefix__filter-4"
        >
          <feOffset dy={-2} in="SourceAlpha" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
            result="shadowInnerInner1"
          />
          <feColorMatrix
            values="0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0.116559222 0"
            in="shadowInnerInner1"
          />
        </filter>
        <filter
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
          id="prefix__filter-7"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.112447732 0 0 0 0 0.470504982 0 0 0 0 0 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <path
          d="M.491 4.743C-1.783 19.348 3.84 30.43 17.361 37.986 30.52 31.031 36.162 19.95 34.29 4.743l-5.774-2.578a27.298 27.298 0 00-22.27.006L.49 4.743z"
          id="prefix__ff-logo-tagline-path-2"
        />
        <path
          d="M21.349 2.794l-4.948 4.5L5.837 6.142l-1.53 1.72 8.208 2.966L1.938 21.282l1.44 1.651 11.561-9.386 3.045 9.658 1.558-1.688-.717-11.504 5.128-4.664c1.634-1.626-.992-4.16-2.604-2.555z"
          id="prefix__ff-tagline-path-5"
        />
        <linearGradient
          x1="50%"
          y1="-6.44%"
          x2="50%"
          y2="113.78%"
          id="prefix__ff-logo-tagline-linearGradient"
        >
          <stop stopColor="#89D500" offset="0%" />
          <stop stopColor="#43A200" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id="prefix__ff-logo-tagline-Product-Logos"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(0 1)" id="prefix__Flexifly-+-Tagline">
          <path
            d="M46.231 63.666V60.85c.301.058.545.07.87.07 1.922 0 3-1.217 3-3.245 0-1.738-.753-2.71-2.12-2.71-.88 0-1.541.463-1.866 1.193h-.023c.058-.313.07-.777.07-1.078h-1.17v8.585h1.24zm.904-3.719c-.348 0-.637-.035-.904-.116V58.06c0-.985.498-2.074 1.425-2.074.776 0 1.136.649 1.136 1.807 0 1.553-.672 2.155-1.657 2.155zm6.476 1.008c1.703 0 2.862-1.332 2.862-3.105 0-2.027-1.09-2.885-2.63-2.885-1.75 0-2.873 1.333-2.873 3.07 0 2.028 1.042 2.92 2.641 2.92zm.116-1.066c-.962 0-1.471-.683-1.471-1.981 0-1.32.73-1.9 1.483-1.9.984 0 1.46.695 1.46 1.923 0 1.332-.673 1.958-1.472 1.958zm6.418.95l.87-2.78c.15-.487.277-.939.393-1.449h.012c.104.44.208.835.336 1.217l.996 3.012h1.367l1.842-5.758h-1.286l-.8 2.723c-.173.579-.289 1.03-.405 1.564h-.011a19.678 19.678 0 00-.452-1.622l-.87-2.665h-1.25l-.858 2.711c-.15.498-.29 1.008-.405 1.576h-.012c-.116-.522-.278-1.066-.428-1.61l-.765-2.677h-1.355l1.772 5.758h1.31zm9.187.116c.707 0 1.414-.128 1.993-.37l-.116-.986a3.97 3.97 0 01-1.68.371c-1.147 0-1.737-.602-1.703-1.935H71.5a5.68 5.68 0 00.035-.579c0-1.367-.707-2.49-2.352-2.49-1.68 0-2.63 1.297-2.63 3.035 0 2.027.985 2.954 2.78 2.954zm.962-3.789h-2.445c.105-.776.591-1.285 1.286-1.285.73 0 1.182.498 1.159 1.285zm3.881 3.673v-2.34c0-1.726.556-2.526 1.703-2.317l.058-1.217c-1.077-.104-1.657.614-1.912 1.39h-.023c.081-.44.116-.95.116-1.274h-1.182v5.758h1.24zm5.19.116c.707 0 1.414-.128 1.993-.37l-.116-.986a3.97 3.97 0 01-1.68.371c-1.147 0-1.738-.602-1.703-1.935h3.673a5.68 5.68 0 00.035-.579c0-1.367-.707-2.49-2.352-2.49-1.68 0-2.63 1.297-2.63 3.035 0 2.027.985 2.954 2.78 2.954zm.962-3.789h-2.445c.105-.776.591-1.285 1.286-1.285.73 0 1.182.498 1.159 1.285zm4.298 3.789c.892 0 1.564-.487 1.877-1.193h.023a6.954 6.954 0 00-.081 1.077h1.17v-8.457h-1.228v2.653c-.313-.023-.59-.047-.869-.047-1.865 0-3.012 1.275-3.012 3.256 0 1.668.707 2.71 2.12 2.71zm.336-1.02c-.788 0-1.147-.648-1.147-1.807 0-1.552.672-2.155 1.657-2.155.301 0 .602.035.915.104v1.785c0 .984-.51 2.073-1.425 2.073zm9.037.997c1.911 0 3.058-1.263 3.058-3.256 0-1.738-.753-2.71-2.12-2.71-.846 0-1.53.451-1.83 1.17h-.024c.07-.302.105-.765.105-1.101v-2.653h-1.24v8.306c.626.163 1.24.244 2.05.244zm.092-.985c-.359 0-.648-.035-.903-.116v-1.784c0-.973.498-2.05 1.425-2.05.776 0 1.135.637 1.135 1.795 0 1.553-.672 2.155-1.657 2.155zm4.102 3.8c1.297 0 1.865-.556 2.537-2.352l2.386-6.314h-1.332l-.823 2.34c-.208.591-.451 1.333-.567 1.796h-.012a16.883 16.883 0 00-.452-1.506l-.938-2.63h-1.39l2.155 5.758-.232.614c-.36.985-.684 1.251-1.263 1.251-.266 0-.498-.034-.753-.127l-.093 1.089c.232.046.545.081.777.081zm11.597-2.815c.753 0 1.482-.14 2.073-.371l-.15-1.124c-.429.209-1.113.36-1.645.36-1.703 0-2.48-1.032-2.48-2.85 0-1.634.742-2.885 2.375-2.885.568 0 1.124.092 1.692.266l.139-1.158a7.74 7.74 0 00-1.726-.22c-2.63 0-3.858 1.772-3.858 4.205 0 2.085.961 3.777 3.58 3.777zm4.726-.093v-8.457h-1.24v8.457h1.24zm4.125.116c.706 0 1.413-.128 1.992-.37l-.115-.986a3.97 3.97 0 01-1.68.371c-1.147 0-1.738-.602-1.703-1.935h3.672a5.68 5.68 0 00.035-.579c0-1.367-.707-2.49-2.352-2.49-1.68 0-2.63 1.297-2.63 3.035 0 2.027.985 2.954 2.78 2.954zm.961-3.789h-2.444c.104-.776.59-1.285 1.286-1.285.73 0 1.181.498 1.158 1.285zm3.847 3.789c.915 0 1.633-.51 1.911-1.193l.012.011a7.683 7.683 0 00-.058 1.066h1.193a35.353 35.353 0 01-.035-1.576v-2.351c0-1.182-.486-1.947-2.247-1.947-.742 0-1.46.162-2.028.383l.116 1.054c.487-.301 1.182-.464 1.715-.464.904 0 1.205.371 1.205 1.09v.37c-2.074 0-3.395.765-3.395 2.086 0 .915.626 1.47 1.61 1.47zm.37-.973c-.486 0-.787-.278-.787-.707 0-.498.393-1.043 2.2-1.043v.116c0 .823-.567 1.634-1.413 1.634zm5.724.857v-2.34c0-1.726.556-2.526 1.703-2.317l.058-1.217c-1.078-.104-1.657.614-1.912 1.39h-.023c.08-.44.116-.95.116-1.274h-1.182v5.758h1.24zm4.715.104c.382 0 .81-.058 1.147-.127v-1.02c-.22.058-.498.093-.753.093-.58 0-.753-.232-.753-1.089v-2.757h1.506v-.962h-1.518v-2.166l-1.228.336v1.83h-1.1v.962h1.1v3.14c0 1.285.37 1.76 1.599 1.76zm3.719-.104v-2.34c0-1.726.556-2.526 1.703-2.317l.058-1.217c-1.078-.104-1.657.614-1.912 1.39h-.023c.081-.44.116-.95.116-1.274h-1.182v5.758h1.24zm3.498-6.615a.786.786 0 00.788-.776c0-.44-.359-.777-.788-.777-.44 0-.799.348-.799.777 0 .428.36.776.8.776zm.615 6.615v-5.758h-1.24v5.758h1.24zm3.046 2.827V60.85c.302.058.545.07.87.07 1.923 0 3-1.217 3-3.245 0-1.738-.753-2.71-2.12-2.71-.88 0-1.541.463-1.865 1.193h-.024c.058-.313.07-.777.07-1.078h-1.17v8.585h1.24zm.904-3.719c-.347 0-.637-.035-.904-.116V58.06c0-.985.499-2.074 1.425-2.074.777 0 1.136.649 1.136 1.807 0 1.553-.672 2.155-1.657 2.155z"
            id="prefix__poweredbyCleartrip"
            fill="#212121"
            fillRule="nonzero"
          />
          <path
            d="M63.085 9.798h-10.81v8.154h10.202v5.014H52.276v13.31h-6.084V4.642h16.893v5.155zm10.81 26.477h-5.99V2.065h5.99v34.21zm25.502-13.402c0 .796-.047 1.734-.188 2.718H84.797c-.047 4.358 2.106 6.467 6.41 6.467 2.294 0 4.774-.516 6.786-1.453l.561 4.64c-2.48.984-5.428 1.5-8.329 1.5-7.393 0-11.511-3.703-11.511-11.904 0-7.123 3.93-12.372 10.903-12.372 6.785 0 9.78 4.64 9.78 10.404zm-5.943-1.36c.093-2.905-1.498-4.639-4.024-4.639-2.48 0-4.212 1.828-4.54 4.64h8.564zm31.913 14.762h-7.534l-4.492-7.826-4.492 7.826h-7.16l8.002-11.762-7.534-11.528h7.16l4.492 7.685 4.54-7.685h6.597l-7.253 11.481 7.674 11.81zM135.85 6.33c0 2.015-1.685 3.655-3.744 3.655s-3.696-1.64-3.696-3.655c0-1.968 1.637-3.608 3.696-3.608 2.06 0 3.744 1.593 3.744 3.608zm-.749 29.945h-5.99v-23.29h5.99v23.29zm27.842 0H157V6.8a19.325 19.325 0 00-3.276-.282c-3.322 0-5.007 1.406-5.007 4.5v1.968h5.1v4.639h-5.1v18.651h-5.943V17.624h-4.07v-4.64h4.07v-2.249c0-5.39 3.276-9.091 11.465-9.091 2.386 0 5.568.328 8.703.796v33.835zm26.58-23.29l-9.547 25.446c-2.76 7.264-5.194 9.467-10.528 9.467-1.03 0-2.293-.141-3.276-.375l.374-5.155c1.077.328 2.06.515 3.182.515 1.966 0 3.276-.89 4.493-4.358l.795-2.25-8.563-23.29h6.645l3.135 8.904c.702 2.015 1.31 4.31 1.825 6.42h.047c.514-2.11 1.497-5.202 2.246-7.405l2.76-7.92h6.411z"
            id="prefix__Flexi\xDFy"
            fill="#231F20"
            fillRule="nonzero"
          />
          <g id="prefix__ff-logo-tagline-Logo">
            <mask id="prefix__ff-logo-tagline-mask-3" fill="#fff">
              <use xlinkHref="#prefix__ff-logo-tagline-path-2" />
            </mask>
            <g id="prefix__ff-logo-tagline-Mask">
              <use
                fill="url(#prefix__ff-logo-tagline-linearGradient)"
                xlinkHref="#prefix__ff-logo-tagline-path-2"
              />
              <use
                fill="#000"
                filter="url(#prefix__filter-4)"
                xlinkHref="#prefix__ff-logo-tagline-path-2"
              />
            </g>
            <g
              id="prefix__Path-20-Copy"
              mask="url(#prefix__ff-logo-tagline-mask-3)"
            >
              <g transform="translate(2.158 5.28)">
                <mask id="prefix__ff-logo-tagline-mask-6" fill="#fff">
                  <use xlinkHref="#prefix__ff-tagline-path-5" />
                </mask>
                <g
                  id="prefix__Mask"
                  stroke="none"
                  fill="none"
                  transform="rotate(9 13.203 12.743)"
                >
                  <use
                    fill="#000"
                    filter="url(#prefix__filter-7)"
                    xlinkHref="#prefix__ff-tagline-path-5"
                  />
                  <use fill="#FFF" xlinkHref="#prefix__ff-tagline-path-5" />
                </g>
                <path
                  d="M1.93 18.389c.19.299.416.644.678 1.036.263.391.572.826.929 1.303l-1.606.917a96.956 96.956 0 00-.763-1.36 24.64 24.64 0 01-.535-.99l1.298-.906z"
                  id="prefix__Path-20-Copy"
                  stroke="none"
                  fill="#E8E8E8"
                  fillRule="evenodd"
                  mask="url(#prefix__ff-logo-tagline-mask-6)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
